import Url from 'urlinator/Url';
function sanitizePathname(pathname) {
  const lastIndex = pathname.length - 1;
  if (pathname.charAt(lastIndex) === '/') {
    return pathname.substring(0, lastIndex);
  }
  return pathname;
}
export function getSlug(href = '') {
  /**
   * If the pathname contains "/meetings/" (old domain pattern, custom domain pattern)
   * then we should split pathname on 'meetings' to grab the slug
   * Otherwise, we are on the domain pattern meetings.hubspot.com
   * and the slug is just the pathname with leading '/' removed
   * @param {string} href url to parse to get the unique identifier
   * @returns {string} The visible unique identifier of the meeting link
   */
  const url = new Url(href);
  const pathname = sanitizePathname(url.pathname);

  // On HubSpot meetings domains (e.g. meetings-na2.hubspot.com), the /meetings/
  // segment in the pathname is part of the slug, not a prefix to strip.
  // Only strip /meetings/ for app domains and custom domains.
  // We match against the full hubspot(qa).com pattern to avoid false-positives
  // on custom domains whose hostname happens to start with "meetings".
  const isMeetingsDomain = /^meetings(-[\w\d]+)?\.hubspot(qa)?\.com$/.test(url.hostname);
  if (!isMeetingsDomain && pathname.indexOf('/meetings/') > -1) {
    return pathname.split('/meetings/')[1];
  }
  return pathname.slice(1);
}